import React from 'react'
import V2Theme, { V2ThemeProps } from '../V2'
import APMNavbar from './Navbar'
import { ThemeSlots } from '../interfaces'
import AdditionalResources from './AdditionalResources'
import Reputation from './Reputation'
import Footer from './Footer'

const APMTheme: React.FC<V2ThemeProps> = (props) => {
  const { campaign } = props
  const { style } = campaign

  const slots: ThemeSlots = {
    NavBar: (
      <APMNavbar
        background={style?.background}
        border={{ color: style?.borderColor }}
        url={campaign.meta.logo?.url}
        navbarThemeStyle={campaign.theme?.properties?.style?.navbar}
      />
    ),
    PostMain: (
      <>
        <AdditionalResources />
        <Reputation />
      </>
    ),
    Footer: (
      <Footer />
    )
  }

  // Pass all props to V2Theme with custom slots
  return <V2Theme {...props} slots={slots} />
}

export default APMTheme